// document status action types
export const SET_DOCUMENTSTATUS_DATA = "SET_DOCUMENTSTATUS_DATA";
export const ADD_DOCUMENTSTATUS = "ADD_DOCUMENTSTATUS";
export const UPDATE_DOCUMENTSTATUS = "UPDATE_DOCUMENTSTATUS";
export const DELETE_DOCUMENTSTATUS = "DELETE_DOCUMENTSTATUS";
